import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { sendEvent } from '../../shared/search-event';
import theme from '../../../assets/stylesheets/_settings.global.scss';
import LogoSeparator from '../shared/logo-separator';
import OrganisationResultsContext, { reducer, defaultState } from './organisation-results-components/context';
import PublishedBy from './organisation-results-components/published-by';
import MentionedWires from './organisation-results-components/mentioned-wires';
import Contributors from './organisation-results-components/contributors';
import TopStockCodes from './organisation-results-components/top-stock-codes';
import TopKeywords from './organisation-results-components/top-keywords';
import TopAreasOfExpertise from './organisation-results-components/top-areas-of-expertise';

const Columnar = styled.div`
  padding-top: ${props => (props.theme.isDesktop ? 49 : 25)}px;

  & section.sidebar > article:first-child {
    margin-top: 0;
  }
`;

export default function SearchResultsOrganisation({ organisation }) {
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });
  const isDesktop = useMediaQuery({ query: `(min-width: ${theme.breakpointLargeMax})` });
  const [st, dispatch] = React.useReducer(reducer, defaultState);

  React.useEffect(() => {
    (async () => sendEvent())();
  }, []);

  const className = isDesktop || isMobile ? 'columnar' : 'columnar no-sidebar';

  return (
    <ThemeProvider theme={{ ...theme, isDesktop }}>
      <OrganisationResultsContext.Provider value={{ state: st, dispatch }}>
        <React.Fragment>
          <Columnar className={className}>
            <section className="content">
              {!isDesktop && (
                <React.Fragment>
                  <MentionedWires organisation={organisation} />
                  <Contributors organisation={organisation} />
                  <TopStockCodes organisation={organisation} />
                  <TopKeywords organisation={organisation} />
                  <TopAreasOfExpertise organisation={organisation} />
                </React.Fragment>
              )}
              <PublishedBy organisation={organisation} />
              {!!(st.publishedByWires.length) && (
                <LogoSeparator animate={st.loadingPublishedBy === 'more'} />
              )}
            </section>
            {isDesktop && (
              <section className="sidebar">
                <MentionedWires organisation={organisation} />
                <Contributors organisation={organisation} />
                <TopStockCodes organisation={organisation} />
                <TopKeywords organisation={organisation} />
                <TopAreasOfExpertise organisation={organisation} />
              </section>
            )}
          </Columnar>
        </React.Fragment>
      </OrganisationResultsContext.Provider>
    </ThemeProvider>
  );
}

SearchResultsOrganisation.propTypes = {
  organisation: PropTypes.string.isRequired,
};
